import React, { useEffect, useState } from 'react';
import SNR_BNFTS_V2_Header from '../../Includes/Layouts/ADV_2/SNR_BNFTS_V2_Header';
import SNR_BNFTS_V2_Main from '../../Includes/Layouts/ADV_2/SNR_BNFTS_V2_Main';
import AdtopiaLoadLPAP from '../../../Utility/AdtopiaLoadLPAP';
import { Months } from '../../../Constants/Constants';
// import '../../../../src/assets/css/SNR_BNFTS_V2.scss';
import stickyBanner from '../../../../src/assets/SNR_BNFTS_V2/img/sticky-banner.jpg';
import AnchorAdvV2 from '../../UI/AnchorAdvV2.js';
import { getQueryString } from '../../../Utility/QueryString';

const SNR_BNFTS_V2 = () => {
  var now = new Date();
  const year = now.getFullYear();
  const date = now.getDate();
  const monthIndex = now.getMonth();
  const monthName = Months[monthIndex];
  const formatted = ` ${monthName} ${date}, ${year}`;
  const splitName ='2025_art/senior_benefits/v2';
  const queryString = getQueryString();
  const uuid = new URLSearchParams(queryString).get('uuid');
  useEffect(() => {
    const handlePageShow = (event) => {
      const navEntries = performance.getEntriesByType("navigation");
      const navEntry = navEntries.length > 0 ? navEntries[0] : null;
      const isBackNav = navEntry?.type === 'back_forward' || event.persisted;
      console.log('isBackNav:', isBackNav);
      if (isBackNav) {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
  
  return (
    <>
      {/* <AdtopiaLoadAP pageType="AP" splitName="2025_art/senior_benefits/v2" /> */}
      <AdtopiaLoadLPAP splitName={splitName}/>
      <div className="SNR_BNFTS_V2">
        <div className="h-top-bar">
          <div className="container">
            {/* <p>One major benefit you don't want to miss: You could be eligible for a car finance refund. Find out more
              inside.</p> */}
              <p>
              £Billions for Seniors Set Aside. May 25' Moratorium Announced. Act Now to Avoid Disappointment.
              <AnchorAdvV2
                dataId="HEADER_TEXT_LINKS"
                className="prequalify-link"
              > Click Here to Pre-qualify. </AnchorAdvV2>
              </p>
          </div>
        </div>
        <SNR_BNFTS_V2_Header />
        {/* <div className="sticky-banner">
          <img
            src={stickyBanner}
            alt="Sticky Banner"
            className="img-fluid d-none d-md-block"
          />
        </div> */}
        <SNR_BNFTS_V2_Main />
      </div>
    </>
  );
};

export default SNR_BNFTS_V2;
